import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import MakeStoriesComponent from './js/make-stories.component';

ComponentsFactory.getInstance().define('make-stories', MakeStoriesComponent);
